
(function(){
  if(!window.location.pathname.includes('/blogs/')) return;

  var keyToAccessJudgeme = '29IU1IkTBvw2F3G4O-dJy7ACDOQ';
  var countryName = sessionStorage.getItem("countryName") || getCookie("countryName") || '';
 
  $('div[id*=blog_products_]:not(#blog_products_container)').each(function(){
    var $this = $(this);
    var divcount = this.id.split('blog_products_')[1];
    var blogProducts = $this.find('.blog_product_name').val().replace(/& /g,'').replace(/ /g,'-');

    $.ajax({
      url: window.Shopify.routes.root + 'products/' + blogProducts + '.js',
      dataType: 'json',
      success: function(product) {
        var blogProductGrid = $('#product-card-template').html();
        var isAvailable = product.available;
        
        blogProductGrid = blogProductGrid
          .replaceAll('blog_product_id', product.id)
          .replaceAll('blog_product_variant_id', product.variants[0].id)
          .replaceAll('blog_product_url', product.url)
          .replaceAll('blog_product_handle', product.handle)
          .replaceAll('blog_product_featured_image', product.featured_image)
          .replaceAll('blog_product_title', product.title)
          .replaceAll('blog_product_add_to_cart_text', 'Add to cart')
          .replaceAll('blog_product_price', formatMoney(product.price, $('body').data('money-format')))
        if (product.compare_at_price) {
          var discount = ( (product.compare_at_price - product.price) * 100 / product.compare_at_price ).toFixed(2);
            blogProductGrid = blogProductGrid
            .replaceAll('blog_product_was_price', formatMoney(product.compare_at_price, $('body').data('money-format')))
            .replaceAll('blog.product.discount', Math.round(discount) + '%');
        } else {
          blogProductGrid = blogProductGrid
            .replaceAll('blog_product_was_price', '')
            .replaceAll('blog.product.discount', '');
        }
        
        $('#blog_products_' + divcount).append(blogProductGrid);
        if(isAvailable){
          document.querySelector('.sold-out-button-' + product.id).style.display = 'none';
          if(product.variants.length > 1)
          {
            document.querySelector('.single-product-' + product.id).style.display = 'none';
          }
          else
          {
            document.querySelector('.quick-buy-container-' + product.id).style.display = 'none';
          }
        }else{
          document.querySelector('.quick-buy-container-' + product.id).style.display = 'none';
          document.querySelector('.single-product-' + product.id).style.display = 'none';
        }

        getProductReviews(product.id, divcount);
      }
    });
  });

  function getProductReviews(productId, divcount){
    $.ajax({
      url: 'https://judge.me/api/v1/widgets/product_review',
      data: {
        api_token: keyToAccessJudgeme,
        shop_domain: 'browntaped.myshopify.com',
        external_id: productId
      },
      dataType: 'json',
      success: function(itemData) {
        var reviewsWidget = $(itemData.widget);
        if(reviewsWidget.data('number-of-reviews') > 0){
          var noofQuestions = reviewsWidget.data('number-of-questions');
          var container = $('#blog_products_' + divcount).find('.product-details1');

          if (container.find('.jdgm-rev-widg__header').length === 0) {
            container.append(reviewsWidget.find('.jdgm-rev-widg__header'));
    }
          
          container.find('.jdgm-rev-widg__title').remove();
          var summaryText = container.find('.jdgm-rev-widg__summary-text');
          if(summaryText.length){
            summaryText.html(summaryText.html().replace("Based on", ""));
          }

          container.find('.judgeme_reviews_action').attr("href", function(_, href){
            return href + '#judgeme_product_reviews';
          });

          container.find('div.jdgm-rev-widg__summary-stars').replaceWith(function(){
            return '<span class="jdgm-rev-widg__summary-stars" aria-label="'+$(this).attr("aria-label")+'" role="img">'+$(this).html()+'</span>';
          });
          container.find('div.jdgm-rev-widg__summary-text').replaceWith(function(){
            return '<span class="jdgm-rev-widg__summary-text">'+$(this).html()+'</span>';
          });
        }
      }
    });
  }

  function getCookie(name){
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }
  

})();
